export default __webpack_public_path__ + "static/media/heading.a0279d64.svg";